import React, { useId, useRef } from 'react';
import './RadioButton.css';

interface RadioButtonProps extends React.InputHTMLAttributes<HTMLInputElement> {
  dark?: boolean;
  parentClassName?: string;
}

const RadioButton: React.FC<RadioButtonProps> = ({ dark, parentClassName, className, id, ...props }) => {
  const generatedId = useId();
  const inputId = id || `radio-${generatedId}`;
  const inputRef = useRef<HTMLInputElement>(null);
  const wrapperRef = useRef<HTMLDivElement>(null);
  
  // Make the wrapper clickable to trigger the input
  const handleWrapperClick = (e: React.MouseEvent) => {
    // Don't trigger if clicking directly on the input (it handles its own click)
    if (e.target === inputRef.current) {
      return;
    }
    // If clicking on the wrapper or span, trigger the input
    if (inputRef.current) {
      inputRef.current.click();
    }
  };
  
  return (
    <div 
      ref={wrapperRef}
      className={`radio-button-wrapper ${parentClassName || ''} ${dark ? 'dark' : ''} ${className || ''}`}
      onClick={handleWrapperClick}
    >
      <input {...props} ref={inputRef} id={inputId} type="radio" className="radio-button-input" />
      <span className="radio-button-span" style={{ color: '#0F1C32' }}></span>
    </div>
  );
};

export default RadioButton;

